module.exports = require("@bechtel/client-assets/dist/images/pipe-icon.svg");